module.exports = __webpack_public_path__ + "static/Saleh_new-2dfa92d4a50331c0674b5ebd8fb369a3.svg";